import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallet = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.5 5.5V7.78C21.09 8.13 21.5 8.76 21.5 9.5V15.5C21.5 16.24 21.09 16.87 20.5 17.22V19.5C20.5 20.6 19.6 21.5 18.5 21.5H4.5C3.39 21.5 2.5 20.6 2.5 19.5V5.5C2.5 4.4 3.39 3.5 4.5 3.5H18.5C19.6 3.5 20.5 4.4 20.5 5.5ZM12.5 15.5H19.5V9.5H12.5V15.5ZM4.5 19.5V5.5H18.5V7.5H12.5C11.4 7.5 10.5 8.4 10.5 9.5V15.5C10.5 16.6 11.4 17.5 12.5 17.5H18.5V19.5H4.5ZM14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 2,
			y: 3,
			width: 24,
			height: 19,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.5 5.5V7.78C21.09 8.13 21.5 8.76 21.5 9.5V15.5C21.5 16.24 21.09 16.87 20.5 17.22V19.5C20.5 20.6 19.6 21.5 18.5 21.5H4.5C3.39 21.5 2.5 20.6 2.5 19.5V5.5C2.5 4.4 3.39 3.5 4.5 3.5H18.5C19.6 3.5 20.5 4.4 20.5 5.5ZM12.5 15.5H19.5V9.5H12.5V15.5ZM4.5 19.5V5.5H18.5V7.5H12.5C11.4 7.5 10.5 8.4 10.5 9.5V15.5C10.5 16.6 11.4 17.5 12.5 17.5H18.5V19.5H4.5ZM14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
	]
});
const ForwardRef = forwardRef(SvgWallet);
export default ForwardRef;
